import { useMutation } from '@tanstack/vue-query'
import type { UpdateContractInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useViewer } from '#imports'

export function useRecurringProgramUpdateContractMutation() {
    const query = useRpQuery()
    const activeFacility = useActiveFacility()
    const viewer = useViewer()

    return useMutation({
        mutationFn: (mutationData: UpdateContractInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation RecurringProgramUpdateContractMutation(
                        $input: UpdateContractInput!
                        $facilityId: ID!
                        $capacityResultFilter: CapacityResultFilter!
                        $bookingStatusFilter: BookingStatusAvailableFilter!
                    ) {
                        updateContract(input: $input) {
                            __typename
                            ... on UpdateContractResult {
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseRecurringProgramContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    capacityResultFilter: {
                        ignoreContractId: mutationData.id
                    },
                    bookingStatusFilter: {
                        customerId: viewer.value?.customerId ?? null
                    }
                }
            )
    })
}
